import { Button } from '@flowus/common/components';
import type { FC } from 'react';
import { useCurrentUser } from 'src/hooks/user';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { SettingModalCommon } from '../common';
import { useOpenChangePhoneOrEmailDialog } from './account-phone';

export const AccountEmail: FC = () => {
  const { t } = useAppTranslation();
  const currentUser = useCurrentUser();

  const openChangePhoneOrEmailDialog = useOpenChangePhoneOrEmailDialog();

  return (
    <SettingModalCommon.Item
      leftChild={
        <div className="space-y-0.5">
          <div>{t('common.email')}</div>
          <div className="text-t4 text-grey3">{currentUser.email}</div>
        </div>
      }
      rightChild={
        <Button onClick={() => openChangePhoneOrEmailDialog('email')}>
          {t('components.setting_modal.email.change_email')}
        </Button>
      }
    />
  );
};
